export const moduleInfoFields = ['name', 'description', 'thumbnail', 'time_restricted'];

export const modulePeopleChanged = (draft, saved, key) => !!saved &&
    JSON.stringify((draft?.[key] || []).map(person => person.id).sort()) !==
    JSON.stringify((saved[key] || []).map(person => person.id).sort());

export const getModuleSubmission = (draft, saved, section, creating = false) => {
    const fields = section === 'info' ? moduleInfoFields : [section];
    return JSON.parse(JSON.stringify(creating ? draft : {
        ...saved,
        ...Object.fromEntries(fields.map(key => [key, draft[key]])),
        duration: draft.duration
    }));
};
